import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/itfirst.webp';
import screenshot_target from '../../../images/letterfunnel/inesdewit.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Inès de Wit"
      firstname="Inès"
      companyname="IT FIRST"
      competition="Dustin en Bechtle"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/insdewit.js